export const RoleTypes = {
  CONTRIBUTOR_TO_CONSUMER: 'CONTRIBUTOR_TO_CONSUMER', // Contributing Directly to Consumer
  PROVIDER_ON_BEHALF_OF: 'POB', // Provider On Behalf Of Contributor
  PROVIDER_ON_BEHALF_OF_PRINCIPALS: 'POBOP', // Provider On Behalf Of Principals
  CONTRIBUTOR_OR_PROVIDER_TO_AGENT: 'CONTRIBUTOR_OR_PROVIDER_TO_AGENT', // Contributing to Agent who is Receving On Behalf Of his Principals

  // PULL roles
  CONSUMER_FROM_CONTRIBUTOR: 'CONSUMER_FROM_CONTRIBUTOR', // Consuming Directly from Contributor/Provider
  CONSUMER_ON_BEHALF_OF: 'COB', // Receiver On Behalf Of Consumer
  CONSUMER_ON_BEHALF_OF_PRINCIPALS: 'COBOP', // Receiver On Behalf Of Principals
  CONSUMER_OR_RECEIVER_FROM_AGENT: 'CONSUMER_OR_RECEIVER_FROM_AGENT' // Consuming from Agent who is Providing On Behalf Of his Principals
}

export const CombinedFlows = {
  CONTRIBUTOR_ONLY: 'CONTRIBUTOR_ONLY',                 
  POB_ONLY: 'POB_ONLY',          
  POBOP_ONLY: 'POBOP_ONLY',                      
  CONTRIBUTOR_POB: 'CONTRIBUTOR_POB',           
  POB_POBOP: 'POB_POBOP',            
  CONTRIBUTOR_POBOP: 'CONTRIBUTOR_POBOP',           
  CONTRIBUTOR_POB_POBOP: 'CONTRIBUTOR_POB_POBOP',
  CONSUMER_ONLY: 'CONSUMER_ONLY',                 
  COB_ONLY: 'COB_ONLY',          
  COBOP_ONLY: 'COBOP_ONLY',                      
  CONSUMER_COB: 'CONSUMER_COB',           
  COB_COBOP: 'COB_COBOP',            
  CONSUMER_COBOP: 'CONSUMER_COBOP',           
  CONSUMER_COB_COBOP: 'CONSUMER_COB_COBOP',      
}

export const RecipientTypes = {
  AGENT: 'AGENT',
  NON_AGENT: 'NON_AGENT',
  MY_PITSTOP: 'MY_PITSTOP',
}

export const ParticipantTypes = RecipientTypes;

export const TransactionTypes = {
  PUSH_STORE: 'PUSH_STORE',
  PUSH_TO_AGENT: 'PUSH_TO_AGENT',

  // PULL transaction types
  PULL: 'PULL',
  PULL_FROM_AGENT: 'PULL_FROM_AGENT',
}

export const FlowDirection = {
  PUSH: 'PUSH',
  PULL: 'PULL'
}
